//DAOSection3

// src/components/DAOSection3.js
import React from 'react';
import styled from 'styled-components';

const SectionContainer = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5%; 
  background-color: #000000; /* 调整背景颜色根据需要 */
  width:60%;
  margin: 0 auto;

  @media (max-width: 500px) {
    flex-direction: column; /* 在小于500px时，垂直排列 */
    padding: 5% 0% 0% 0%;
    width:90vw;
  }
`;

const LeftColumn = styled.div`
  flex: 4;
  align-self: flex-start;
  @media (max-width: 500px) {

    width:100%;
    text-align: center;
    
  }
  
`;

const Image = styled.img`
  width: 100%;
  height: auto;
`;



const RightColumn = styled.div`
  flex: 6; 
  width:60%;
  overflow: hidden;
  padding:0% 0% 0% 5%;

  @media (max-width: 500px) {
    
    width:100%;
    padding:0% ;

  }
  
`;

const GroupContainer = styled.div`
  margin-bottom: 2.5%; 
  margin-left: 2.5%; 

  padding:1%;

  div {
    display:flex;
    flex-direction: row;
    margin-left: 2.5%; 
    margin-top: 0%; 
    gap:20px;

    a{
      text-decoration: none;
    }


  }

  @media (max-width: 500px) {
    width:100%;
    margin:0 auto;
   
    padding:0%;

    div{
     margin-top: 10%;  
     margin-bottom: 5%;  
     margin-left:20%;
    }

  }
`;

const GroupTitle = styled.h3`
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 500;
  font-size: 28px;
  line-height: 41px;
  margin-bottom: 1%;
  margin-top: 1%; 
  color: #FFFFFF;
  padding:0% 0% 0% 3%;


  p{

    font-size: 18px;
    line-height: 32px;
    color: #AFAFAF;
    margin-bottom: 0%;

  }

  @media (max-width: 500px) {
    font-weight: 500;
    font-size: 18px;
    line-height: 26px;
    padding:5% 0% 0% 2% ;

    p {
      font-weight: 500;
      font-size: 14px;
      line-height: 24px;
    }
  }

`;

const ReadMoreButton = styled.button`
  background-color: #000000;
  color: #FFFFFF;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.05em;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 40px;
  box-sizing: border-box;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 100px;
  cursor: pointer;
  margin: 0 auto;
  margin-top: 48px;


  @media (max-width: 500px) {
    font-size: 14px;
    line-height: 24px;
    margin-top: 24px;
    padding: 6px 20px;
    margin: 0 auto;
  }

  &:hover {
    background-color: #FFFFFF;
    color: #1f1f1f;
  }
`;

const DAOSection3 = () => {
  return (
    <SectionContainer>
      <LeftColumn>
        <Image src="/images/Web3Sec3_1_pc.png" alt="Image Title" />
      </LeftColumn>
      <RightColumn>
        <GroupContainer>
          <GroupTitle>web3 發展建議報告書 簡介<p>web3 範疇下的分散式技術包含區塊鏈、加密貨幣、智能合約、DAO 和 NFT。這些技術讓去中心化的治理成為可能，將 agency 從傳統的集中權力結構中釋放出來，從根本上改變了傳統網路世界的權力結構。在本文中，我們提出了「web3 公民基礎建設」作為我們的整體框架，利用一整套現有且可行的技術，實現數位身份、彼此關聯、商業、合約和溯源的應用可能。我們為台灣點出了一個具有前瞻性的方向，充分發揮web3 的特性來應對氣候變遷、權力結構不平等和民主法治等重要議題。<br/><br/>Decentralised technologies under the web3 umbrella include blockchain, cryptocurrencies, smart contracts, DAO and NFT. These technologies support new ways of organising and move agency away from its traditional authoritarian sources to networks which allows that agency to be exercised at the level of self-organised communities. In this paper we proposed "web3 civic infrastructure" as our umbrella framework that uses a whole range of generally-available technologies, facilitating identity, association, commerce, contracts, and provenance digitally. We propose a proactive approach for Taiwan, leveraging web3's unique attributes to address critical challenges such as climate, inequality, and democracy.</p></GroupTitle>
          <div>
            <a href="https://drive.google.com/file/d/1ejgn3uVGewD0OFaEBdGiACYQxT8YkcbE/view?usp=drive_link" target="_blank" style={{ textDecoration: 'none' }}><ReadMoreButton>中文版</ReadMoreButton></a>
            <a href="https://www.radicalxchange.org/media/" target="_blank" style={{ textDecoration: 'none' }}><ReadMoreButton>English</ReadMoreButton></a>
          </div>
        </GroupContainer>
        
      </RightColumn>

    </SectionContainer>
    

  );
};

export default DAOSection3;
